import styled from 'styled-components';
import {
  CalendarActive as CalendarActiveIcon,
  CalendarInactive as CalendarInactiveIcon,
  CalendarRoundedInactive,
} from '@root/src/assets/images';
import colors from '@designSystem/colors';
import { zIndicies } from '../../layout/design';

export const CalendarActive = styled(CalendarActiveIcon)`
  margin-left: 8px;
`;

export const CalendarInactive = styled(CalendarInactiveIcon)`
  margin-left: 8px;
`;

export const CalendarActiveNew = styled(CalendarRoundedInactive)`
  & path {
    stroke: ${colors.black};
  }
`;

export const CalendarInactiveNew = styled(CalendarRoundedInactive)`
  & path {
    stroke: ${colors.darkGrey};
  }
`;

export const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const CalendarIconContainer = styled.div<{
  newDesign?: boolean;
}>`
  position: absolute;
  right: 16px;
  top: 6px;
`;

type DateContainerI = {
  inputWidth?: number;
  active?: boolean;
  disabled?: boolean;
  errorMessage?: boolean;
};

export const DateContainer = styled.div<DateContainerI>`
  display: flex;
  flex-direction: column;
  width: ${({ inputWidth }) => (inputWidth ? `${inputWidth}px` : '100%')};
  flex-shrink: ${({ inputWidth }) => (inputWidth ? 0 : 1)};

  .react-datepicker__day {
    width: 2.3rem;
    line-height: 2.3rem;
    color: ${colors.black};
    &:hover {
      border-radius: 50%;
      color: #36b18a;
      background-color: #e6fbee;
      font-weight: 600;
    }
  }

  .react-datepicker__day-name {
    font-size: 12px;
    line-height: 16px;
    color: ${colors.darkGrey};
  }

  .react-datepicker__day,
  .react-datepicker__day-name,
  .react-datepicker__time-name {
    width: 2.3rem;
  }
  .react-datepicker__day--keyboard-selected {
    background: #02bf8e;
    font-weight: 500;
    border-radius: 50% !important;
    color: #fff;
  }
  .react-datepicker {
    border: none;
  }
  .react-datepicker-popper {
    z-index: ${zIndicies.popover};
  }
  .react-datepicker__month-container {
    font-family: 'futura-pt', sans-serif;
    font-style: normal;
    font-weight: 450;
    font-size: 14px;
    line-height: 24px;
    border-radius: 10px;
    box-shadow: 0 4px 24px #dddddd;
    text-align: center;
    padding: 24px;

    color: ${colors.black};
  }
  .react-datepicker__current-month {
    display: flex;
    margin: 2px 0px 24px 0px;
    font-weight: 450;
    font-size: 18px;
    line-height: 24px;
    color: ${colors.black};
  }
  .react-datepicker__header {
    background-color: #ffffff !important;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    padding-top: 8px;
    border-bottom: none;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .react-datepicker__triangle {
    display: none !important;
  }
  .react-datepicker__navigation .react-datepicker__navigation--previous {
    position: absolute;
    margin-left: 50px;
  }
  .react-datepicker__input-container {
    > input {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      padding: 0px 10px 0px 16px;
      background: ${colors.lightGrey};
      border: 1.5px solid
        ${(props) => (props.errorMessage ? colors.red : colors.grey)};
      box-sizing: border-box;
      border-radius: 8px;
      font-family: Arial !important;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: ${colors.black};

      &:hover,
      &:focus {
        border: 1.5px solid ${colors.grey};
      }
    }
  }
  .react-datepicker__day--in-selecting-range {
    :hover {
      background-color: #02bf8e;
      color: #fff;
    }
  }

  .react-datepicker__day--in-selecting-range {
    background-color: #e6fbee;
    border-radius: 50%;
    color: #02bf8e;
  }

  .react-datepicker__day--selected {
    background: #02bf8e;
    border-radius: 50%;
    color: #fff;
  }
  .react-datepicker__day--keyboard-selected {
    border-radius: 0.3rem;
  }
  .react-datepicker__day--today {
    font-weight: bold;
    border-radius: 50%;
  }
  .react-datepicker__input-container {
    margin-left: 0;
  }
  .react-datepicker__close-icon::after {
    background-color: #02bf8e;
    font-size: 14px;
    padding: 1px;
  }
  .react-datepicker__navigation {
    margin-left: 30px;
    margin-right: 30px;
    top: 32px;
  }

  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker__navigation-icon::before {
    border-width: 2px 2px 0 0;
    border-color: ${colors.grey};
  }
`;

export const DateGroup = styled.div`
  display: flex;
  flex-direction: column;
`;
